<div class="page-title-area"  >
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                 
                 
                    <ul>
                        <li><a routerLink="/job-list">Dashboard</a></li>
  
            
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Vakaturanan Apliká</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dashboard-area pt-100" >
    <div class="container">
        <div class="row align-items-center">
         <div class="col-lg-12">
                <div class="dashboard-img">
                   <!--- <img src="assets/img/dashboard/1.jpg" alt="Dashboard"> -->
                 
                    
                </div>
            </div>
       

            <app-dashpills></app-dashpills>
<!-- Spinner Section -->
<div *ngIf="isLoading" class="text-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

<div class="row" *ngIf="!isLoading">
    <div *ngIf="appliedJobs.length > 0" class="col-lg-12 mix text-center" > <h3>Bo a Apliká na {{appliedJobs.length}} Vakatura</h3></div>
    <div *ngIf="appliedJobs.length == 0" class="col-lg-12 mix text-center" > <h3>Bo no a Apliká na un Vakatura.</h3>
                </div>

    </div>
</div>
            <div class="row" *ngIf="!isLoading">
             
                <div *ngFor="let job of appliedJobs" class="col-lg-8 mix" style="margin: 0 auto;">
                    <div class="job-item">
                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>{{ job.title }}</h3>
                                <a>{{ job.companyName }}</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i> {{ job.salary }}</li>
                                    <li><i class="icofont-book"></i> {{ job.qualification }}</li>
                                </ul>
                            </div>
                            <div class="job-inner-right">
                                <div class="d-lg-block mb-2">
                                    <!-- Assuming job.logo is a URL to the logo image -->
                                    <img src="{{ job.logo }}" alt="Job" class="job-details-logo">
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-lg sign-up-btn mt-4" style="background:#061f35; width:50%; border-radius: 0; border:0;" ><i class="icofont-info-circle"></i> Mas Informashon</button>
                        <button type="button" class="btn btn-primary btn-lg sign-up-btn mt-4" style="background:#FF0000; width:50%; border-radius: 0; border:0;" (click)="deleteApplication(job.jobId)"><i class="icofont-trash"></i> Mi no ta Interesá mas</button>
                     
                    </div>
                </div>
            </div>
   




